export const postAuthOfLeadMerge = {
    // "method": "POST",
    // headers: {
    "Content-Type": "application/json"
    // },
};

export const postAuthForFile = {
    "Content-Type": "text/csv",
};

export const getRequestOptions = {
    "method": "GET",
    // "mode": "no-cors",
    headers: {
        "Content-Type": "application/json"
    }
};

export const updateAuthOfLeadMerge = {
    "Content-Type": "application/json"
};

export const deleteAuthOfLeadMerge = {
    "method": "DELETE",
    "mode": "cors",
    headers: {
        "Content-Type": "application/json"
    }
};